// Shared image helper — downscale a picked File to a JPEG data URL.
// Used for chat photo attachments (hub + app) and anywhere a quick,
// size-bounded inline image is needed without a Storage round-trip.

export function downscaleToDataUrl(file: File, maxPx = 1280, quality = 0.7, mime = "image/jpeg"): Promise<string> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const im = new Image();
    im.onload = () => {
      const scale = Math.min(maxPx / im.naturalWidth, maxPx / im.naturalHeight, 1);
      const w = Math.max(1, Math.round(im.naturalWidth * scale));
      const h = Math.max(1, Math.round(im.naturalHeight * scale));
      const c = document.createElement("canvas");
      c.width = w; c.height = h;
      const ctx = c.getContext("2d");
      if (!ctx) { URL.revokeObjectURL(url); return reject(new Error("no canvas")); }
      ctx.drawImage(im, 0, 0, w, h);
      URL.revokeObjectURL(url);
      resolve(c.toDataURL(mime, quality));
    };
    im.onerror = () => { URL.revokeObjectURL(url); reject(new Error("bad image")); };
    im.src = url;
  });
}

// logos: keep PNG (alpha) so they sit cleanly on white branded docs; cap size
export function logoToDataUrl(file: File): Promise<string> {
  return downscaleToDataUrl(file, 480, 1, "image/png");
}
